module.exports = __webpack_public_path__ + "static/media/arrowDown.306b01a9.svg";